export default {
  router: [
    {
      exact: true,
      path: '/CarrierManagement/tmsReconciliation',
      title: '调度核对趟次',
    },
  ],
  title: '调度核对趟次',
};
